import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import colors from 'vuetify/es5/util/colors'

Vue.use(Vuetify, {
  iconfont: 'md',
    theme: {
      primary: "#01579b", // #E53935
      secondary:"#0288d1", // #FFCDD2
      accent: colors.indigo.base // #3F51B5
    }
})
